
<h5>Buscar: </h5>
<input 
    type="text" 
    class="form-control" 
    placeholder="Buscar Gif..."
    (keyUp.enter) ='buscar()'
    #txtBuscar
>